/**
 * The study list: the openings and lines the user said they want to work on (docs/STUDY-LIST.md).
 *
 * Three screens put things in it — the report, /explore and the ranking of their own games — and a
 * row has to know whether it is already in there, so the list is read once and kept here. Null
 * means nobody has asked the server yet, which is not the same as an empty list.
 */
export const studyListSlice = {
    items: null,
};
